import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  Divider,
  Select,
  MenuItem,
  Radio,
  FormControl,
  FormControlLabel,
  RadioGroup
} from "@material-ui/core";
import {
  lightBlue,
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,
  grey,
  blueGrey
} from "@material-ui/core/colors";

import { FirebaseContext } from "../../FirebaseInit";
import myStyles from "./Style";

class SettingsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryColor: this.props.appearance.primaryColor,
      secondaryColor: this.props.appearance.secondaryColor,
      theme: this.props.appearance.theme,
    };

    this.updateSettings = this.updateSettings.bind(this);
    this.ChangeTheme = this.ChangeTheme.bind(this);
  }

  ChangeTheme(firebase, e) {
    const name = e.target.name
    const value = e.target.value
    this.props.toggleLoading()
    firebase
      .fs()
      .collection("users")
      .doc(this.props.user.uid)
      .collection("private")
      .doc("theme")
      .set(
        {
          [name]: value
        },
        { merge: true }
      )
      .then(() => {
        this.setState({ [name]: value });
        this.props.toggleLoading()
      })
      .catch(err => {
        this.props.toggleAlert("An error occured. Please try again.", "error");
        this.props.toggleLoading()
      });
  }

  updateSettings() {}
  render() {
   // const { classes } = this.props;
    const firebase = this.context;
    const MenuProps = {
      style: {
        zIndex: "1400"
      }
    };
    const ColorPicker = props => (
      <Select
        name={props.name}
        MenuProps={MenuProps}
        value={props.color}
        onChange={this.ChangeTheme.bind(this, firebase)}
      >
        <MenuItem value={lightBlue[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={lightBlue[700]}
            ></Box>
            lightBlue
          </Box>
        </MenuItem>

        <MenuItem value={blue[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={blue[700]}
            ></Box>
            blue
          </Box>
        </MenuItem>
        <MenuItem value={indigo[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={indigo[700]}
            ></Box>
            indigo
          </Box>
        </MenuItem>
        <MenuItem value={red[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={red[700]}
            ></Box>
            red
          </Box>
        </MenuItem>
        <MenuItem value={pink[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={pink[700]}
            ></Box>
            pink
          </Box>
        </MenuItem>
        <MenuItem value={orange[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={orange[700]}
            ></Box>
            orange
          </Box>
        </MenuItem>
        <MenuItem value={deepOrange[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={deepOrange[700]}
            ></Box>
            deepOrange
          </Box>
        </MenuItem>
        <MenuItem value={purple[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={purple[700]}
            ></Box>
            purple
          </Box>
        </MenuItem>
        <MenuItem value={deepPurple[700]}>
          <Box display="flex">
            {" "}
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={deepPurple[700]}
            ></Box>
            deepPurple
          </Box>
        </MenuItem>
        <MenuItem value={cyan[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={cyan[700]}
            ></Box>
            cyan
          </Box>
        </MenuItem>
        <MenuItem value={green[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={green[700]}
            ></Box>
            green
          </Box>
        </MenuItem>
        <MenuItem value={grey[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={grey[700]}
            ></Box>
            grey
          </Box>
        </MenuItem>
        <MenuItem value={brown[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={brown[700]}
            ></Box>
            brown
          </Box>
        </MenuItem>
        <MenuItem value={blueGrey[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={blueGrey[700]}
            ></Box>
            blueGrey
          </Box>
        </MenuItem>
        <MenuItem value={yellow[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={yellow[700]}
            ></Box>
            yellow
          </Box>
        </MenuItem>
        <MenuItem value={lime[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={lime[700]}
            ></Box>
            lime
          </Box>
        </MenuItem>
        <MenuItem value={lightGreen[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={lightGreen[700]}
            ></Box>
            lightGreen
          </Box>
        </MenuItem>
        <MenuItem value={teal[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={teal[700]}
            ></Box>
            teal
          </Box>
        </MenuItem>
        <MenuItem value={amber[700]}>
          <Box display="flex">
            <Box
              mr={2}
              width={20}
              height={20}
              borderRadius="50%"
              bgcolor={amber[700]}
            ></Box>
            amber
          </Box>
        </MenuItem>
      </Select>
    );
    return (
      <>
        <Box my={2}>
          <Typography paragraph variant="h6" color="primary">
            Primary color
          </Typography>
          <ColorPicker name="primaryColor" color={this.state.primaryColor} />
        </Box>

        <Divider />
        <Box my={2}>
          <Typography paragraph variant="h6" color="primary">
            Secondary color
          </Typography>
          <ColorPicker
            name="secondaryColor"
            color={this.state.secondaryColor}
          />
        </Box>

        <Divider />
        <Box my={2}>
          <Typography paragraph variant="h6" color="primary">
            Theme
          </Typography>

          <FormControl component="fieldset">
            <RadioGroup
              name="theme"
              onChange={this.ChangeTheme.bind(this, firebase)}
              value={this.state.theme}
            >
              <FormControlLabel
                value="light"
                label="Light"
                control={<Radio color="primary" />}
              />
              <FormControlLabel
                value="dark"
                label="Dark"
                control={<Radio color="primary" />}
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </>
    );
  }
}
SettingsDialog.contextType = FirebaseContext;
export default withStyles(myStyles)(SettingsDialog);
